module.exports = __webpack_public_path__ + "static/media/impact-analysis-file-upload.08fbf044.svg";